export function startsWithFilter(option, props) {
  const optionWords = option[props.labelKey].toLowerCase().split(/\s+/); // Split option label into words
  const inputWords = props.text.toLowerCase().split(/\s+/); // Split user input into words

  return inputWords.every((inputWord) =>
    optionWords.some((optionWord) => optionWord.startsWith(inputWord)),
  );
}
